import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import FormControlLabel from '@material-ui/core/FormControlLabel/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField/TextField';
import { WithStyles } from 'decorators/withStyles';
import { INotification } from 'interfaces/IToast';
import React, { Component } from 'react';

interface IProps {
  classes?: any;
  notification?: INotification;
  enableOrDisableScript?: Function;
  changeText?: Function;
  position?: number;
}

@WithStyles(() => ({
  fontName: {
    fontSize: '1rem',
    color: '#596375'
  },
  contentScripts: {
    display: 'flex',
    flexDirection: 'column'
  },
  script: {
    display: 'flex',
    justifyContent: 'space-between',
    '@media screen and (max-width: 960px)': {
      flexDirection: 'column'
    }
  },
  idDiv: {
    minWidth: 85,
    height: 45.5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ccc',
    position: 'relative',
    border: '1px solid #ccc',
    zIndex: 2,
    borderRadius: '4px 0px 0px 4px'
  },
  idTextField: {
    display: 'flex',
    marginBottom: 20,
    width: 145
  },
  switch: {
    padding: '20px 0'
  },
  input: {
    textAlign: 'center'
  },

  gtLt: {
    justifyContent: 'space-evenly',
    padding: 20
  },

  inputRadius: {
    borderRadius: '0 4px 4px 0',
    '@media screen and (max-width: 960px)': {
      width: '100%'
    }
  }
}))
export default class ToastItem extends Component<IProps, null> {
  notificationText = () => {
    switch (this.props.position) {
      case 1: {
        return 'Última compra foi concluída nos últimos x minutos';
      }
      case 2: {
        return 'x pessoas compraram este produto nas últimas 24 horas';
      }
      case 3: {
        return 'x pessoas compraram este produto na última semana';
      }
      case 4: {
        return 'x pessoas estão acessando este produto';
      }
      case 5: {
        return 'x pessoas se interessaram por este produto nas últimas 24 horas';
      }
      case 6: {
        return 'x pessoas se interessaram por este produto na última semana';
      }
      default: {
        return '';
      }
    }
  };

  render() {
    const { classes, notification } = this.props;

    if (!notification) {
      return null;
    }
    return (
      <div className={classes.contentScripts}>
        <div className={classes.switch}>
          <FormControlLabel
            classes={{ label: classes.fontName }}
            control={
              <Switch
                disableRipple
                checked={notification.enabled}
                onChange={this.props.enableOrDisableScript.bind(this, notification.id)}
                value={'notification.enabled'}
              />
            }
            label={this.notificationText()}
          />
        </div>
        <Collapse in={notification.enabled}>
          <div className={classes.minMax}>
            <div className={classes.idTextField}>
              <div className={classes.idDiv}>{notification.gt !== undefined ? 'maior que' : 'menor que'}</div>
              <TextField
                value={notification.gt !== undefined ? notification.gt : notification.lt}
                InputProps={{
                  classes: { root: classes.inputRadius }
                }}
                type={'number'}
                onChange={this.props.changeText.bind(this, notification.id)}
              />
            </div>
          </div>
        </Collapse>
        <Divider />
      </div>
    );
  }
}
